import React from 'react'
import PropTypes from 'prop-types'
import { Switch as RouterSwitch, Redirect, withRouter } from 'react-router-dom'
import PrivateRoute from '../../hocs/PrivateRoute'
import ChangesPage from './ChangesPage'
import PeoplePage from './PeoplePage'
import UsagePage from './UsagePage'

// The Inventory assistant's own router: the bot manages cars from Telegram, and these three pages are
// how the team sees what it did, who may command it, and what it costs.
const InventoryAssistantRoutes = ({ match }) => (
  <RouterSwitch>
    <Redirect exact from={match.path} to={`${match.path}/changes`} />
    <PrivateRoute exact path={`${match.path}/changes`} component={ChangesPage} />
    <PrivateRoute exact path={`${match.path}/people`} component={PeoplePage} />
    <PrivateRoute exact path={`${match.path}/usage`} component={UsagePage} />
  </RouterSwitch>
)

InventoryAssistantRoutes.propTypes = { match: PropTypes.object }

export default withRouter(InventoryAssistantRoutes)
